// extracted by mini-css-extract-plugin
export var back = "ParagraphShareableCarousel-module--back--2a074";
export var imagewrapper = "ParagraphShareableCarousel-module--imagewrapper--19a01";
export var innercontainer = "ParagraphShareableCarousel-module--innercontainer--0abeb";
export var navbuttons = "ParagraphShareableCarousel-module--navbuttons--366fc";
export var next = "ParagraphShareableCarousel-module--next--a9f32";
export var sharedog = "ParagraphShareableCarousel-module--sharedog--a77f7";
export var sharetoicons = "ParagraphShareableCarousel-module--sharetoicons--b53fd";
export var sharetools = "ParagraphShareableCarousel-module--sharetools--9f932";
export var swiper = "ParagraphShareableCarousel-module--swiper--49491";